import React from 'react';
import {SchemaProps} from "../../../types/Schema";
import {Link} from "react-router-dom";

type OpenSchemaValidationActionProps = {
  schema?: SchemaProps;
  schemaId?: string;
  disabled?: boolean;
};

/**
 * Generic action for opening a schema in the playground with validation section loaded.
 */
export default function OpenSchemaValidationAction(props: OpenSchemaValidationActionProps) {
  const schemaId = props.schemaId || props.schema?.id || '';
  const title = 'View Report';
  const tooltip = 'Open schema playground to view the validation report';
  if (props.disabled) {
    return <span className="btn btn-primary disabled OpenSchemaValidationAction">{title}</span>
  }
  const linkTo = `/schema/playground?id=${schemaId}`;
  return <Link to={linkTo} title={tooltip} className="btn btn-primary OpenSchemaValidationAction">{title}</Link>
}
